import React from "react";
import { useI18n } from "Hooks";
import { Tooltip } from "@toddle-edu/ds-web";
import classes from "./LockingTimerComponent.scss";
import { LockFilled } from "@toddle-edu/ds-icons";
import useLockingTimer from "../Hooks/useLockingTimer";

const LockingTimerComponent = ({ scheduledAt, onTimerStopCallback }) => {
  const { lockingTimer, seconds } = useLockingTimer({
    scheduledAt,
    onTimerStopCallback,
  });
  const { t } = useI18n(["common"]);

  const tooltip = t("locking_in_label", {
    label: lockingTimer,
  });

  if (seconds < 0) return null;
  return (
    <Tooltip tooltip={tooltip}>
      <div className={classes.lockingContentWrapper}>
        <LockFilled size={"xxxx-small"} variant={"critical"} />
        <span>{lockingTimer}</span>
      </div>
    </Tooltip>
  );
};

export default LockingTimerComponent;
